var exports = {
  "FI": "xdde3148b--fd0081--parameters",
  "wx": "xdde3148b--fd0081--header",
  "nM": "xdde3148b--fd0081--row",
};

module.exports = exports;
